import { render, staticRenderFns } from "./CKRecord.vue?vue&type=template&id=40cf7ef8&"
import script from "./CKRecord.vue?vue&type=script&lang=js&"
export * from "./CKRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports